var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"order":"2"}},[_c('map-sidebar')],1),_c('b-col',{staticClass:"sticky-map-col",attrs:{"lg":"9","order-lg":"2"}},[_c('map-view',{staticClass:"mapview-height"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }